import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Typography,
  Grid,
  Button,
  Chip,
  Checkbox,
  FormControlLabel,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import axios from "axios";
import PackageServices from "../../services/externalServices/TourPackageServices/packageServices";
import { useNavigate } from "react-router-dom";
function Packages() {
  const [packages, setPackages] = useState([]);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false); // Delete confirmation dialog state
  const [packageToDelete, setPlaceToDelete] = useState(null); // Store the place to delete
  const navigate = useNavigate();

  useEffect(() => {
    // Replace with your API endpoint
    getPackages();
  }, []);

  const getPackages = async () => {
    try {
      const response = await PackageServices.getPackages();
      setPackages(response);
    } catch (err) {
      console.log("error getting the packages", err);
    }
  };
  const navigateToEdit = (id) => {
    navigate(`/editPackage/${id}`);
  };

  const navigateToCreate = () => {
    navigate("/editPackage");
  };

  const handleDeleteDialogOpen = (id) => {
    setPlaceToDelete(id);
    setOpenDeleteDialog(true);
  };

  // Close Delete Confirmation Dialog
  const handleDeleteDialogClose = () => {
    setOpenDeleteDialog(false);
    setPlaceToDelete(null);
  };

  const handleDeletePlace = async () => {
    if (packageToDelete) {
      try {
        await PackageServices.deletePackage(packageToDelete); // Assuming a deletePlace service function exists
       getPackages() // Refresh the list after deletion
        handleDeleteDialogClose();
      } catch (error) {
        console.log("Error deleting place", error);
      }
    }
  };

  return (
    <Box sx={{ padding: 4 }}>
      <Typography variant="h4" sx={{ marginBottom: 4 }}>
        Manage Packages
      </Typography>
      <Box sx={{ marginBottom: 4 }}>
        <Button
          variant="contained"
          color="primary"
          onClick={navigateToCreate}
        >
          Create New Package
        </Button>
      </Box>

      <Grid container spacing={3}>
        {packages.map((pkg) => (
          <Grid item xs={12} sm={6} md={4} key={pkg._id}>
            <Card
              sx={{
                maxWidth: 345,
                borderRadius: 2,
                boxShadow: 3,
                cursor: "pointer",
                "&:hover": {
                  boxShadow: 6,
                  transform: "scale(1.05)",
                  transition: "transform 0.3s, box-shadow 0.3s",
                },
                transition: "transform 0.3s, box-shadow 0.3s",
              }}
              onClick={() => navigateToEdit(pkg._id)}
            >
              <CardMedia
                component="img"
                height="180"
                image={pkg.thumbnailImage}
                alt={pkg.listTitle}
              />
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  {pkg.listHeading}
                </Typography>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                  {pkg.listSubheading}
                </Typography>
                <Typography variant="body2" sx={{ marginBottom: 2 }}>
                  <strong>City:</strong> {pkg.city} ({pkg.cityScope})
                </Typography>
                <Chip
                  label={`Type: ${pkg.type}`}
                  color="primary"
                  size="small"
                />
                <Chip
                  label={`Days: ${pkg.totalDays}`}
                  sx={{ marginLeft: 1 }}
                  color="secondary"
                  size="small"
                />
                <Typography
                  variant="body2"
                  sx={{ marginTop: 2, fontWeight: 500 }}
                >
                  Best Seasons: {pkg.bestSeasons.join(", ")}
                </Typography>
              </CardContent>

              <Box sx={{ display: "flex", alignItems: "center", padding: 2 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={pkg.isEnabled}
                      
                    />
                  }
                  label="Enabled"
                />
                <Typography variant="body2"  sx={{ fontWeight: 500 }}>
                  Priority: {pkg.priority}
                </Typography>
              </Box>

              <Box sx={{ padding: 2 }}>
                <Button
                  variant="contained"
                  size="small"
                  color="primary"
                  onClick={() => navigateToEdit(pkg._id)}
                >
                  Edit
                </Button>
                <Button
                  variant="outlined"
                  size="small"
                  color="error"
                  sx={{ marginLeft: 1 }}
                  onClick={(e) => {
                    e.stopPropagation(); // Prevent the card click event
                    handleDeleteDialogOpen(pkg._id); // Open the delete dialog
                  }}
                >
                  Delete
                </Button>
              </Box>
            </Card>
          </Grid>
        ))}
      </Grid>
      {/* Delete Confirmation Dialog */}
      <Dialog
        open={openDeleteDialog}
        onClose={handleDeleteDialogClose}
        aria-labelledby="delete-place-dialog-title"
      >
        <DialogTitle id="delete-place-dialog-title">
          Confirm Deletion
        </DialogTitle>
        <DialogContent>
          <Typography>Are you sure you want to delete this place?</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteDialogClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleDeletePlace} color="primary">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default Packages;
